import React from 'react';
import eyeClickLogo from '../../../assets/image/eyclick-logo.svg';

export default function Logo() {
  return <img src={eyeClickLogo} alt="EyeClick Logo" />;
}
